import * as fs from "fs";

export const imageLoader = async (
  src: string,
  width: number,
  height: number
): Promise<IImageDimension> => {
  return await new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => {
      const dimension = calculateAspectRatioFit(
        image.width,
        image.height,
        width,
        height
      );

      resolve(dimension);
      reject();
    };

    image.src = src;
  });
};
// calculate aspect ratio of image
export const calculateAspectRatioFit = async (
  srcWidth: number,
  srcHeight: number,
  maxWidth: number,
  maxHeight: number
): Promise<IImageDimension> => {
  return await new Promise((resolve, reject) => {
    let ratio = 0;

    if ((maxWidth / srcWidth) * srcHeight <= maxHeight) {
      ratio = maxWidth / srcWidth;
    } else {
      ratio = maxHeight / srcHeight;
    }

    resolve({
      ratio: ratio,
      oWidth: srcWidth,
      oHeight: srcHeight,
      width: srcWidth * ratio,
      height: srcHeight * ratio,
    });
    reject();
  });
};

export const randomStringGenerator = (length: number = 10): string => {
  const str = Math.random().toString(36).substring(2, length);
  return `${str}.jpg`;
};

export const downloadPhotoFromUrl = async (src: string): Promise<void> => {
  if (!src) return Promise.reject("`src` has been missed.");

  const srcArraySplitedWithSlash = src
    .split("/")
    .flatMap((url) => url.split("?"));
  const name = srcArraySplitedWithSlash
    .filter((part) => part.endsWith(".jpeg") || part.endsWith(".zip"))
    .pop();

  try {
    const response = await fetch(src);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const anchor = document.createElement("a");
    anchor.href = url;
    if (name) {
      anchor.download = name;
    } else {
      anchor.download = "image.jpeg";
    }

    anchor.style.display = "none";
    document.body.appendChild(anchor);

    anchor.target = "_self";
    anchor.click();

    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);

    return Promise.resolve();
  } catch (error) {
    const anchor = document.createElement("a");

    anchor.href = src;
    anchor.download = src;

    anchor.click();

    return Promise.resolve();
  }
};

export const delay = (func: Function, delay: number) => {
  setTimeout(() => {
    func();
  }, delay);
};

export const sprintf = (string: string, ...argv: any[]): string => {
  return !argv.length
    ? string
    : sprintf((string = string.replace("$", argv.shift())), ...argv);
};

export const generateUUID = () => {
  const randomBytes = new Uint8Array(16);
  crypto.getRandomValues(randomBytes);

  randomBytes[6] = (randomBytes[6] & 0x0f) | 0x40;
  randomBytes[8] = (randomBytes[8] & 0x3f) | 0x80;

  const uuid = Array.from(randomBytes)
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");

  return `${uuid.substr(0, 8)}-${uuid.substr(8, 4)}-${uuid.substr(
    12,
    4
  )}-${uuid.substr(16, 4)}-${uuid.substr(20)}`;
};

export const convertBase64ToBinaryDataAsync = async (
  canvas: HTMLCanvasElement
): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob);
      } else {
        reject(new Error("Failed to create blob."));
      }
    }, "image/png");
  });
};
